export type ENV = keyof Config

interface Config {
    qa: AppConfig
    prod: AppConfig
    local: AppConfig
}

interface AppConfig {
    env: ENV
    basePath: string // backend url
    callbackUrl: string // frontend url
    adminBaseUrl: string
    adyen: AdyenConfig
    customerOnboardingWebsiteUrl: string
}

interface AdyenConfig {
    env: string
    clientKey: string
    caBaseUrl: string
}

const env = (import.meta.env.VITE_ENV as ENV) || 'local'
const configOptions = {
    local: {
        env,
        basePath: 'http://localhost:8087',
        callbackUrl: 'http://localhost:3000',
        adminBaseUrl: 'http://localhost:4200',
        adyen: {
            env: 'test',
            clientKey: 'test_WBWR7KKSYNDW3OQGSLQRUNWGWIYLFY5Q',
            caBaseUrl: 'https://ca-test.adyen.com',
        },
        customerOnboardingWebsiteUrl: 'https://onboarding.qa.favrit.com',
    },
    localQa: {
        env,
        basePath: 'https://qa.favrit.com/ws/payment-service-v2',
        callbackUrl: 'http://localhost:3000',
        adminBaseUrl: 'https://admin.qa.favrit.com',
        adyen: {
            env: 'test',
            clientKey: 'test_WBWR7KKSYNDW3OQGSLQRUNWGWIYLFY5Q',
            caBaseUrl: 'https://ca-test.adyen.com',
        },
        customerOnboardingWebsiteUrl: 'https://onboarding.qa.favrit.com',
    },
    qa: {
        env,
        basePath: 'https://qa.favrit.com/ws/payment-service-v2',
        callbackUrl: 'https://payment.qa.favrit.com',
        adminBaseUrl: 'https://admin.qa.favrit.com',
        adyen: {
            env: 'test',
            clientKey: 'test_WBWR7KKSYNDW3OQGSLQRUNWGWIYLFY5Q',
            caBaseUrl: 'https://ca-test.adyen.com',
        },
        customerOnboardingWebsiteUrl: 'https://onboarding.qa.favrit.com',
    },
    prod: {
        env,
        basePath: 'https://favrit.com/ws/payment-service-v2',
        callbackUrl: 'https://payment.favrit.com',
        adminBaseUrl: 'https://admin.favrit.com',
        adyen: {
            env: 'live',
            clientKey: 'live_DECSCWGCW5DQ3DSIDQSS5QQ64MTQ2G55',
            caBaseUrl: 'https://ca-live.adyen.com',
        },
        customerOnboardingWebsiteUrl: 'https://onboarding.favrit.com',
    },
}

const config: AppConfig = configOptions[env] as AppConfig
export default config
